'use client';

import { useRef } from 'react';
import { RareLogo } from './RareLogo';
import styles from './Footer.module.css';

export const Footer = () => {
  const logoRef = useRef<SVGSVGElement>(null);

  return (
    <footer className={styles.root}>
      <div>
        <h2>
          World&apos;s First Luxury
          <br />
          Smart Ring
        </h2>
        <RareLogo fill={'#ffffff'} ref={logoRef} />
      </div>
    </footer>
  );
};
